import { useChromelessCommunicationChannel } from './useChromelessCommunicationChannel';
import { usePiPObserver } from './usePiPObserver';

/**
 * Sets up mobile native bridge communication and observers for Omega chromeless video.
 *
 * This component facilitates interaction between the web CVSDK video player and the native layer (via WebView),
 * enabling playback control and Picture-in-Picture (PiP) state syncing.
 * @param {object} props - Component properties.
 * @param {React.RefObject<HTMLDivElement>} props.containerRef - Reference to the video container element.
 * @param {boolean} props.autoplayEnabled - Flag indicating if autoplay is enabled for the video.
 */
export const OmegaVideoNativeBridge = ({ containerRef, autoplayEnabled }) => {
  useChromelessCommunicationChannel(autoplayEnabled);
  usePiPObserver(containerRef);
  return null;
};
